import BaseExternalRequestService from "@/modules/core/externalrequest/public/BaseExternalRequestService";
import env from "environment";

class CreditAssignmentExternalRequestService extends BaseExternalRequestService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/public/credit-assignments"
    });
  }
}

const repository = new CreditAssignmentExternalRequestService();

export default repository;
